import {
    createReducer,
} from "../../commons/js/utils/reducer";

const initialState = {
    showPopup: false,
    exceededMessage: "",
};



const reducer = createReducer(initialState, {
    "SET_SHOW_POPUP": (state, action) => {
        return {
            ...state,
            showPopup: action.payload.value,
        };
    },
    "SET_MESSAGE": (state, action) => {
        return {
            ...state,
            exceededMessage: action.payload.value,
        };
    },
});

export default reducer;
